import { CoreBaseService } from "@core/services/Base.service";

// Reference model
import { InspectorModel } from "@models/InspectorModel";

/**
 * An example of service
 * This service is linked to a model and the data returned by the verbs
 * will be instantiated according to the reference model.
 *
 * For more information look at CoreBaseService
 */
class InspectorsService extends CoreBaseService {
  constructor() {
    super(InspectorModel);
  }

  getTotals() {
    return this.sub("totals").get();
  }

  /**
   * Update only the default daily/hourly rate of an inspector.
   * Lightweight partial update used by the inline editing of the inspectors
   * table — hits `PATCH /inspectors/{id}/rate` (UsersController::setRate),
   * which does not require the full user payload.
   */
  setRate(
    id: number,
    payload: {
      default_daily_rate?: number | null;
      default_hourly_rate?: number | null;
    },
  ) {
    return this.sub(`${id}/rate`, InspectorModel).update(payload, -1);
  }

  sendPassword(userId: number) {
    return this.customCall(`send-password/${userId}`).create(null);
  }

  exportInspectors() {
    return this.sub(`export?type=csv`)
      .get(undefined, undefined, true, false, { responseType: "blob" })
      .then((res: any) => {
        res.download("export-inspectors.csv");
      })
      .catch((error) => {
        return error;
      });
  }

  getCities() {
    return this.sub("cities").get(/** code, queryJson */);
  }
}

const inst = new InspectorsService();

export default inst;
